import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, EventService, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent extends BaseCtl {
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    locator.config.getProperty('endpoint.login').then((property: string) => {
      this.initApiEndpoint(property);
    });
  }

  forgotPassword() {
    let _self = this;

    _self.form.message = '';

    let login = _self.form.data['loginId'];

    if (login == null || login.length == 0) {
      _self.form.error = true;
      _self.form.message = 'Please Enter Login Id';
      return;
    } else {
      _self.form.error = false;
      _self.form.message = '';
    }

    let data = {
      loginId: _self.form.data['loginId'],
    };

    let url = _self.locator.config.get('endpoint.login') + '/fp';
    this.locator.http.post(url, data, function (res: any, error: any) {
      if (error) {
        return;
      }
      _self.form.error = !res.success;
      _self.form.message = res.result.message;
    });
  }
}
